// import { environment } from '#environments/environment';
import { environment } from '#environments/environment';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


@Injectable()
export class EnvironmentInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const env = environment.env;

    const request = req.clone({
      headers: req.headers.set('X-Environment', env)
    });

    return next.handle(request);
  }
}
